import * as React from 'react';
import type { StringLiteralDataType } from '@glueapp/graph-types';

interface StringValueEditorProps {
    type: StringLiteralDataType;
}

export const StringLiteralValueEditor: React.FC<StringValueEditorProps> = ({ type }) => {
    return (
        <div className="flex flex-col pt-1">
            <h4 className="text-foreground text-sm m-0 mb-1">{type.stringLiteral}</h4>
        </div>
    );
};
